
        module.exports = __webpack_public_path__ + "assets/images/fwddive-text-white.93f5eda4.svg";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 385,
            height: 65,
            type: "svg",
            bytes: 1523,

            toString: function() {
                return src;
            }
        };
    